import { render, staticRenderFns } from "./RouterViewLayout.vue?vue&type=template&id=78a3264d&"
import script from "./RouterViewLayout.vue?vue&type=script&lang=js&"
export * from "./RouterViewLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports